// Общий счётчик "символов осталось" — вынесен из HeadingSettings (лимит 38, 3
// tone-порога), переиспользуется TextSettings (потолок `DESIGN_TEXT_STUDIO_LIMIT`, только over-limit).
import { cn } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export type CounterTone = 'destructive' | 'warning' | 'primary'

// Динамические классы `text-${tone}`/`bg-${tone}` Tailwind не увидит при сборке —
// нужна явная карта, чтобы каждый класс встретился в исходниках буквально.
const TONE = {
  destructive: { text: 'text-destructive', bar: 'bg-destructive' },
  warning: { text: 'text-warning', bar: 'bg-warning' },
  primary: { text: 'text-primary', bar: 'bg-primary' },
} as const

interface Props {
  used: number
  limit: number
  tone: CounterTone
}

export const CharacterCounter = ({ used, limit, tone }: Props) => {
  const m = useMessages(messages)
  return (
    <div className="rounded-lg border border-border bg-muted/50 p-3">
      <div className="flex items-center justify-between">
        <span className="text-xs text-muted-foreground">{m.charsLeft}</span>
        <span className={cn('text-lg font-semibold tabular-nums', TONE[tone].text)}>
          {limit - used}
        </span>
      </div>
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-muted">
        <div
          className={cn('h-full rounded-full transition-all duration-150', TONE[tone].bar)}
          style={{ width: `${Math.max(0, 100 - (used / limit) * 100)}%` }}
        />
      </div>
    </div>
  )
}
